import React, { Component } from 'react';
import withWidth from '@material-ui/core/withWidth';

class Notification extends Component {
  state = {};

  constructor(props) {
    super(props);
    this.state = { value: '' };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  handleSubmit(event) {
    var link = this.state.value;
    link = link.substring(22, 42); // only for topvesti.bg

    fetch('https://api.grid.mk/api/v1/clusters/' + link, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Language': 'bg',
      },
    })
      .then(response => response.json())
      .then(response => {
        fetch('https://onesignal.com/api/v1/notifications', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            app_id: '1ab6865f-d1cb-4111-a34e-8cf008879649',
            //"include_player_ids": ["71abdf4d-9e4b-4157-bdf4-5ecd337d77f4","776bd0bc-d2d9-4e10-ac27-07920b34ca95"],
            included_segments: ['All'],
            url: this.state.value,
            contents: { en: response.top_article.text.substring(0, 80) },
            headings: { en: response.title.substring(0, 80) },
            chrome_web_icon: response.top_article.thumbnail,
          }),
        })
          .then(response => response.json())
          .then(response => {
            alert(
              'Send to ' +
                response.recipients +
                " users. If you didn't receive notification try again latter after 5min.",
            );
          })
          .catch(function() {
            console.log("Can't send notification for this link. Try again later or with another link.");
          });
      })
      .catch(function() {
        console.log('Invalid link! The link should be from cluster.');
      });

    event.preventDefault();
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <h1>Notifications</h1>
        <h3>Send notifications to all web users!</h3>
        <p>
          <em>Note: Works only for TopVesti.bg</em>
        </p>
        <input
          type="text"
          value={this.state.value}
          onChange={this.handleChange}
          placeholder="(link from cluster)"
          style={{ width: 300 + 'px', padding: 5 + 'px', fontSize: 22 + 'px', marginRight: 12 + 'px' }}
        />
        <button type="submit" style={{ width: 100 + 'px', padding: 5 + 'px', fontSize: 22 + 'px' }}>
          Send
        </button>
      </form>
    );
  }
}

export default withWidth()(Notification);



// WEBPACK FOOTER //
// ./src/notifications/Notification.js